import React from 'react'
import PropTypes from 'prop-types'

import { Card, Form, List } from 'semantic-ui-react'

import Container from './GroupCardContainer'

import Button from 'Components/StandardButton'
import CardProperty from 'Components/CardProperty'

import { THEME_COLOR } from 'Global/constants'

const GroupCard = props => {
  const { group, handleDelete, handleNameChange, handleNameSubmit, name } = props

  return (
    <Card color={THEME_COLOR} fluid raised>
      <Card.Content>
        <Card.Header>
          <Form onSubmit={handleNameSubmit}>
            <Form.Group grouped>
              <Form.Input
                icon="tag"
                loading={false}
                name="name"
                onChange={handleNameChange}
                placeholder="Group Name"
                size="mini"
                value={name}
              />

              <Button content="Update Group Name" icon="check" fluid />
            </Form.Group>
          </Form>
        </Card.Header>
      </Card.Content>

      <Card.Content extra={false}>
        <List />

        {group.users.map(user => (
          <CardProperty icon="user" key={user.id} popUpContent="Group Member">
            {`${user.firstName} ${user.lastName} (${user.id})`}
          </CardProperty>
        ))}
      </Card.Content>

      <Card.Content>
        <Button color="red" content="Delete Group" icon="trash" onClick={handleDelete} fluid />
      </Card.Content>
    </Card>
  )
}

GroupCard.propTypes = {
  group: PropTypes.object.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleNameChange: PropTypes.func.isRequired,
  handleNameSubmit: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
}

export default Container(GroupCard)
